import { createContext } from 'react'

export const ProfileWidgetsExpandContext = createContext(null)
